<div class="container">
  <div class="text-center">
    <mat-icon color="warn">warning</mat-icon>
    <br />
    <p>
      <br /><b>Unable to display the requested resource.</b> <br />
      {{ errorMessage }}
    </p>
  </div>
</div>
